import React, { useState } from 'react';

import { Card, CardBody } from 'reactstrap';

import { LoaderMini } from '~/components/Loaders';
import { Link } from 'react-router-dom';
// import { CarroselCred } from '../CarroselCred';
import {
	Container,
	// DivMontante,
} from './styles';

import { Text } from '../../../../../../components/Text';
import {
	DivView,
	TextMontante,
	ImgMontante,
} from '../CarroselCred/styles';

import { symbolPriceFormatter } from '../../../../../../helpers/price';

import viewOff from '../../../../../../assets/img/iconDash/viewOff.svg';
import viewOn from '../../../../../../assets/img/iconDash/viewOn.svg';

export function MontanteMobile({ data }) {
	const [viewMontante, setViewMontante] = useState(false);
	return (
		<Container>
			<Card
				style={{
					marginBottom: 0,
					marginTop: 0,
					backgroundColor: 'transparent',
					boxShadow: 'none',
				}}>
				<CardBody style={{
					marginBottom: 0,
					marginTop: 0,
				}}>
					<>
						{/* {data.montante === undefined || data.montante === null ? ( */}
						{data && data.montante ? (
							<div style={{
								display: 'flex',
								width: '100%',
								flexDirection: 'column',
								alignItems: 'center',
								marginTop: '0px',
								// height: '100vh'
							}}>
								<Text style={{ textAlign: 'center' }}>
									Montante de Créditos
								</Text>
								<DivView>
									<TextMontante
										style={{ marginRight: '5%' }}>
										<Text
											style={{ fontSize: '30px' }}
											color="softBlack"
											size="big"
											weight='bold'>
											{viewMontante ? symbolPriceFormatter(data.montante) : 'R$ ---'}
											{/* {data && data.montante === '--' ? data.montante : symbolPriceFormatter(data.montante)} */}
										</Text>
									</TextMontante>
									<ImgMontante
										onClick={() => setViewMontante(!viewMontante)}
										alt="viewOff"
										width="25"
										src={viewMontante ? viewOn : viewOff}
									/>
								</DivView>
								<Link to="/client/transacoes">
									<Text style={{ textAlign: 'center', textDecorationLine: 'underline', marginBottom: '10px', fontSize: '12px' }}>
										Ver detalhes
									</Text>
								</Link>
							</div>
						) : (
							<div style={{
								display: 'flex',
								width: '100%',
								flexDirection: 'column',
								alignItems: 'center',
								marginTop: '0px',
								// height: '100vh'
							}}>
								<LoaderMini />
							</div>
						)}
					</>
				</CardBody>
			</Card>
		</Container>
	);
}

